import React from 'react';
import {
  withStyles,
} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';


import InternmentForm from './InternmentForm';

import styles from './InternmentRequestModalStyles';

const InternmentRequestModal = ({classes, open, onClose}) => (
  <Dialog open={open} onClose={onClose} maxWidth={false} disableBackdropClick={true}>
    <div className={classes.header}>
      <p className={classes.headerTitle}>Solicita cerere de internare</p>
      <IconButton className={classes.headerCloseIcon} onClick={onClose}>
        <CloseIcon/>
      </IconButton>
    </div>
    <InternmentForm onClose={onClose} />
  </Dialog>
);

export default withStyles(styles)(InternmentRequestModal);